module.exports = __webpack_public_path__ + "static/img/countdown.3f36c89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countdown.png
// module id = HObD
// module chunks = 1